export default function reducer (state = {}, action) {
  switch (action.type) {
    case 'profile/loading':
      return {
        ...state,
        loading: true,
        error: false
      }
    case 'profile/loaded':
      return {
        ...state,
        error: false,
        loading: false,
        profile: action.profile
      }
    case 'profile/error':
      return {
        ...state,
        loading: false,
        error: action.error
      }
    default:
      return state
  }
}
